/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiPageResponseDailyTripHistoryDailyTripSummary } from '../models/ApiPageResponseDailyTripHistoryDailyTripSummary';
import type { ApiResponseFilteredTripHistoryResponse } from '../models/ApiResponseFilteredTripHistoryResponse';
import type { ApiResponseGetEvDriveStatsResponse } from '../models/ApiResponseGetEvDriveStatsResponse';
import type { ApiResponseGetMainTripResponse } from '../models/ApiResponseGetMainTripResponse';
import type { ApiResponseGetMonthlyDriveStatsResponse } from '../models/ApiResponseGetMonthlyDriveStatsResponse';
import type { ApiResponseGetHmgOdometerResponse } from '../models/ApiResponseGetHmgOdometerResponse';
import type { ApiResponseGetRecentEvDriveStatsResponse } from '../models/ApiResponseGetRecentEvDriveStatsResponse';
import type { ApiResponseGetRecentTripDaysResponse } from '../models/ApiResponseGetRecentTripDaysResponse';
import type { ApiResponseGetRecentTripResponse } from '../models/ApiResponseGetRecentTripResponse';
import type { ApiResponseGetTripDaysResponse } from '../models/ApiResponseGetTripDaysResponse';
import type { ApiResponseGetTripDetailResponse } from '../models/ApiResponseGetTripDetailResponse';
import type { ApiResponseGetTripPathResponse } from '../models/ApiResponseGetTripPathResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class DriveHistoryService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * 최근 주행 이력 조회
   * 차량의 가장 최근 주행 기록을 조회합니다.
   * @returns ApiResponseGetRecentTripResponse OK
   * @throws ApiError
   */
  public getRecentTrip({
    authorization,
    vin,
    ccId,
  }: {
    authorization?: string,
    vin: string,
    ccId: string,
  }): CancelablePromise<ApiResponseGetRecentTripResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/drive-history/trip/recent',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
        'ccId': ccId,
      },
    });
  }
  /**
   * 주행 경로 조회
   * 주행 경로 정보를 조회합니다
   * @returns ApiResponseGetTripPathResponse OK
   * @throws ApiError
   */
  public getTripPath({
    authorization,
    vin,
    ignOnTime,
  }: {
    authorization?: string,
    vin: string,
    ignOnTime: string,
  }): CancelablePromise<ApiResponseGetTripPathResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/drive-history/trip/path',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
        'ignOnTime': ignOnTime,
      },
    });
  }
  /**
   * 주행 이력 상세 조회
   * 주행 상세 정보를 조회합니다
   * @returns ApiResponseGetTripDetailResponse OK
   * @throws ApiError
   */
  public getTripDetail({
    vin,
    tripId,
  }: {
    vin: string,
    tripId: string,
  }): CancelablePromise<ApiResponseGetTripDetailResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/drive-history/trip/detail',
      query: {
        'vin': vin,
        'tripId': tripId,
      },
    });
  }
  /**
   * 최근 주행 날짜 조회
   * 주행 데이터가 있는 가장 최근 월을 파악하고 해당 월의 날짜별 주행 횟수와 가장 최근 주행일을 반환합니다.
   * @returns ApiResponseGetRecentTripDaysResponse OK
   * @throws ApiError
   */
  public getRecentTripDays1({
    authorization,
    vin,
  }: {
    authorization?: string,
    vin: string,
  }): CancelablePromise<ApiResponseGetRecentTripDaysResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/drive-history/trip/days/recent',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
      },
    });
  }
  /**
   * 월별 주행 날짜 조회
   * 주행 이력이 있는 날짜 목록을 조회합니다.
   * @returns ApiResponseGetTripDaysResponse OK
   * @throws ApiError
   */
  public getTripDays1({
    authorization,
    vin,
    ccId,
    month = '202606',
  }: {
    authorization?: string,
    vin: string,
    ccId: string,
    month?: string,
  }): CancelablePromise<ApiResponseGetTripDaysResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/drive-history/trip/days',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
        'ccId': ccId,
        'month': month,
      },
    });
  }
  /**
   * 주행 이력 조회
   * 특정 날짜의 주행 이력을 조회합니다.
   * @returns ApiPageResponseDailyTripHistoryDailyTripSummary OK
   * @throws ApiError
   */
  public getTripHistoryByDate({
    authorization,
    vin,
    ccId,
    date = '20260609',
    page = 1,
    size = 3,
    orderBy = 'DESC',
  }: {
    authorization?: string,
    vin: string,
    ccId: string,
    date?: string,
    page?: number,
    size?: number,
    orderBy?: 'ASC' | 'DESC',
  }): CancelablePromise<ApiPageResponseDailyTripHistoryDailyTripSummary> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/drive-history/trip',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
        'ccId': ccId,
        'date': date,
        'page': page,
        'size': size,
        'orderBy': orderBy,
      },
    });
  }
  /**
   * 주행 이력 필터 조회
   * 날짜 범위와 태그로 주행 이력을 필터링하여 페이지 조회합니다.
   * @returns ApiResponseFilteredTripHistoryResponse OK
   * @throws ApiError
   */
  public getFilteredTripHistory({
    vin,
    startDate,
    endDate,
    tagIds,
    orderBy = 'DESC',
    page,
    size = 20,
  }: {
    vin: string,
    startDate?: string,
    endDate?: string,
    tagIds?: Array<string>,
    orderBy?: 'ASC' | 'DESC',
    page?: number,
    size?: number,
  }): CancelablePromise<ApiResponseFilteredTripHistoryResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/drive-history/trip/filtered',
      query: {
        'vin': vin,
        'startDate': startDate,
        'endDate': endDate,
        'tagIds': tagIds,
        'orderBy': orderBy,
        'page': page,
        'size': size,
      },
    });
  }
  /**
   * 주행 이력 삭제
   * 특정 주행 이력을 삭제합니다.
   * @returns any OK
   * @throws ApiError
   */
  public deleteTripHistory({
    authorization,
    vin,
    ignOnTime,
  }: {
    authorization?: string,
    vin: string,
    ignOnTime: string,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/drive-history/trip',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
        'ignOnTime': ignOnTime,
      },
    });
  }
  /**
   * 누적주행거리 조회
   * 누적주행거리를 조회합니다.
   * @returns ApiResponseGetHmgOdometerResponse OK
   * @throws ApiError
   */
  public getOdometer4({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<ApiResponseGetHmgOdometerResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/drive-history/odometer',
      query: {
        'vin': vin,
      },
    });
  }
  /**
   * 누적주행거리 조회
   * 누적주행거리를 조회합니다.
   * @returns ApiResponseGetHmgOdometerResponse OK
   * @throws ApiError
   */
  public getOdometer5({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<ApiResponseGetHmgOdometerResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/drive-history/odometer/',
      query: {
        'vin': vin,
      },
    });
  }
  /**
   * 월별 주행 기록 조회
   * 차량의 월별 주행 기록을 조회합니다.
   * @returns ApiResponseGetMonthlyDriveStatsResponse OK
   * @throws ApiError
   */
  public getMonthlyDriveStats({
    authorization,
    vin,
    ccId,
  }: {
    authorization?: string,
    vin: string,
    ccId: string,
  }): CancelablePromise<ApiResponseGetMonthlyDriveStatsResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/drive-history/monthly-stats/',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
        'ccId': ccId,
      },
    });
  }
  /**
   * 월별 주행 기록 조회
   * 차량의 월별 주행 기록을 조회합니다.
   * @returns ApiResponseGetMonthlyDriveStatsResponse OK
   * @throws ApiError
   */
  public getMonthlyDriveStats1({
    authorization,
    vin,
    ccId,
  }: {
    authorization?: string,
    vin: string,
    ccId: string,
  }): CancelablePromise<ApiResponseGetMonthlyDriveStatsResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/drive-history/monthly-stats',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
        'ccId': ccId,
      },
    });
  }
  /**
   * 주요주행(위험/안전 Top6) 조회
   * 주요주행(위험/안전 Top6) 정보를 조회 합니다.
   * @returns ApiResponseGetMainTripResponse OK
   * @throws ApiError
   */
  public getMainTrip({
    vin,
    isSafe = false,
    page = 1,
    size = 3,
  }: {
    vin: string,
    isSafe?: boolean,
    page?: number,
    size?: number,
  }): CancelablePromise<ApiResponseGetMainTripResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/drive-history/main-trip',
      query: {
        'vin': vin,
        'isSafe': isSafe,
        'page': page,
        'size': size,
      },
    });
  }
  /**
   * 주요주행(위험/안전 Top6) 조회
   * 주요주행(위험/안전 Top6) 정보를 조회 합니다.
   * @returns ApiResponseGetMainTripResponse OK
   * @throws ApiError
   */
  public getMainTrip1({
    vin,
    isSafe = false,
    page = 1,
    size = 3,
  }: {
    vin: string,
    isSafe?: boolean,
    page?: number,
    size?: number,
  }): CancelablePromise<ApiResponseGetMainTripResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/drive-history/main-trip/',
      query: {
        'vin': vin,
        'isSafe': isSafe,
        'page': page,
        'size': size,
      },
    });
  }
  /**
   * 최근 EV 에너지 사용 정보 조회
   * 최근 EV 에너지 사용 정보를 조회합니다. 최근 데이터는 조회 전일 기준입니다.
   * @returns ApiResponseGetRecentEvDriveStatsResponse OK
   * @throws ApiError
   */
  public getRecentEvDriveStats({
    authorization,
    vin,
    ccId,
  }: {
    authorization?: string,
    vin: string,
    ccId: string,
  }): CancelablePromise<ApiResponseGetRecentEvDriveStatsResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/drive-history/ev-stats/recent/',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
        'ccId': ccId,
      },
    });
  }
  /**
   * 최근 EV 에너지 사용 정보 조회
   * 최근 EV 에너지 사용 정보를 조회합니다. 최근 데이터는 조회 전일 기준입니다.
   * @returns ApiResponseGetRecentEvDriveStatsResponse OK
   * @throws ApiError
   */
  public getRecentEvDriveStats1({
    authorization,
    vin,
    ccId,
  }: {
    authorization?: string,
    vin: string,
    ccId: string,
  }): CancelablePromise<ApiResponseGetRecentEvDriveStatsResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/drive-history/ev-stats/recent',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
        'ccId': ccId,
      },
    });
  }
  /**
   * EV 에너지 사용 정보 조회
   * EV4,PHEV4 차량의 최근 30일 기준 EV 에너지 사용 정보를 조회합니다. 최근 데이터는 조회 전일 기준입니다.
   * @returns ApiResponseGetEvDriveStatsResponse OK
   * @throws ApiError
   */
  public getMonthlyEvDriveStats({
    authorization,
    vin,
    ccId,
  }: {
    authorization?: string,
    vin: string,
    ccId: string,
  }): CancelablePromise<ApiResponseGetEvDriveStatsResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/drive-history/ev-stats/',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
        'ccId': ccId,
      },
    });
  }
  /**
   * EV 에너지 사용 정보 조회
   * EV4,PHEV4 차량의 최근 30일 기준 EV 에너지 사용 정보를 조회합니다. 최근 데이터는 조회 전일 기준입니다.
   * @returns ApiResponseGetEvDriveStatsResponse OK
   * @throws ApiError
   */
  public getMonthlyEvDriveStats1({
    authorization,
    vin,
    ccId,
  }: {
    authorization?: string,
    vin: string,
    ccId: string,
  }): CancelablePromise<ApiResponseGetEvDriveStatsResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/drive-history/ev-stats',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
        'ccId': ccId,
      },
    });
  }
}
